<template>
    <tr class="even:bg-neutral5/5">
        <slot />
    </tr>
</template>
